






































import Vue from 'vue';
import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue';
import Logo from '@/components/common/Logo.vue';
import Page from '@/components/Page.vue';
import Card from '@/components/common/Card.vue';
import CTAButton from '@/components/common/buttons/CTAButton.vue';
import PlusIcon from '../assets/img/plus.svg';
import TertiaryButton from '@/components/common/buttons/TertiaryButton.vue';
import { createNamespacedHelpers, mapState } from 'vuex';
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
const mapSessionState = createNamespacedHelpers('session').mapState;

export default Vue.extend({
    components: {
        TertiaryButton,
        CTAButton,
        Card,
        Page,
        Logo,
        LanguageSwitcher,
        PlusIcon,
    },
    computed: {
        ...mapCustomLabelsState([
            'portalTitle',
            'instanceTitle',
            'homePageText',
            'createGrievanceTitle',
            'accessGrievanceBtn',
            'viewGrievance',
        ]),
        ...mapState(['isLoading', 'grievanceHideLogo']),
        ...mapSessionState(['portalAccessToken']),
        shouldShowLogo(): boolean {
            return !this.grievanceHideLogo;
        },
    },
    created() {
        document.title = `${this.instanceTitle} | ${this.portalTitle}`;
    },
});
